<template>
    <div class="markdown-msg" :class="$platform.pc ? 'pc' : ''">
      <div class="content" v-html="html"></div>
      <div v-if="isMsgComplete && referenceData && referenceData.length" class="reference">
        <div class="tit">参考来源：</div>
        <div v-for="item in referenceData" :key="item.url" class="article-link">
          <a :href="item.url" target="_blank">
            <svg class="icon-papers"><use xlink:href="../assets/papers.svg#papers" /></svg>
            <span>{{ item.name }} &gt;</span>
          </a>
        </div>
      </div>
    </div>
</template>
<script>
// highlight
const hljs = require('highlight.js/lib/core');
// 需要支持的语言
hljs.registerLanguage('javascript', require('highlight.js/lib/languages/javascript'));
hljs.registerLanguage('c', require('highlight.js/lib/languages/c'));
hljs.registerLanguage('cpp', require('highlight.js/lib/languages/cpp'));
hljs.registerLanguage('python', require('highlight.js/lib/languages/python'));
hljs.registerLanguage('php', require('highlight.js/lib/languages/php'));
hljs.registerLanguage('xml', require('highlight.js/lib/languages/xml'));
hljs.registerLanguage('bash', require('highlight.js/lib/languages/bash'));
hljs.registerLanguage('go', require('highlight.js/lib/languages/go'));
hljs.registerLanguage('java', require('highlight.js/lib/languages/java'));
hljs.registerLanguage('shell', require('highlight.js/lib/languages/shell'));

const md = require('markdown-it')({
  // 语法高亮
  highlight(str, lang) {
    if (lang && hljs.getLanguage(lang)) {
      try {
        return `<pre class="hljs"><div class="overflow-x-auto"><code class="hljs-code language-${lang}">${hljs.highlight(str, { language: lang }).value}</code></div></pre>`;
      } catch (ex) {
      }
    }

    return `<pre class="hljs"><div class="overflow-x-auto"><code class="hljs-code language-${lang}">${md.utils.escapeHtml(str)}</code></div></pre>`;
  },
});

export default {
  props: {
    message: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      // 显示的内容
      html: '',
      // 消息内容
      msgContent: '',
      // 获取到完整的内容。
      fullContent: '',
      // 当前显示位置
      currentIndex: 0,
      // 打印动画计时器
      fakeTypingTimer: null,
    };
  },
  computed: {
    /** 是否AI生成的消息 */
    isAiCreatedMsg() {
      return this?.message?.content?.ai_reply?.payload?.is_llm_generated;
    },

    /** 消息片段是否已经收取完成 */
    isMsgComplete() {
      // 当是AI创建的消息时，只有 is_final 才表示消息接收完毕，可以渲染某些内容了。
      return this.isAiCreatedMsg ? (this.message?.content?.is_final && this.contentCompleted) : true;
    },

    /** 消息是否完全输出了 */
    contentCompleted() {
      return this.msgContent === this.fullContent;
    },

    /** 是否有参考文献 */
    referenceData() {
      const reference = this?.message?.content?.ai_events?.find(item => item.type === 'reference');
      if (reference) {
        // 会返回多个相同的引用。根据url进行去重。
        let uniqRfs = null;
        const rfs = reference?.payload?.references;
        if (rfs && rfs.reduce) {
          uniqRfs = rfs.reduce((arr, current) => {
            if (!arr.find(item => item.url === current.url)) {
              arr.push(current);
            }
            return arr;
          }, []);
        }
        return uniqRfs;
      }
      return null;
    },
  },
  watch: {
    'message.content': {
      deep: true,
      immediate: true,
      handler(val) {
        const outString = val?.ai_reply?.payload?.content;
        this.fullContent = outString || '';
      },
    },
    // 当内容变更时，重新解析内容
    msgContent: {
      immediate: true,
      handler(val) {
        // 后半部分内容为假光标效果
        // const tmpContent = `${val}qdOwnCursorSign`;
        const tmpContent = val + (!this.isMsgComplete ? 'qdOwnCursorSign' : '');
        this.html = md.render(tmpContent).replace(/qdOwnCursorSign/, ' <span class="cursor"></span>');
        this.$emit('contentUpdate', this.contentCompleted);
      },
    },
    // 全量内容变化时，进行动态输出处理。
    fullContent: {
      immediate: true,
      handler() {
        this.animateMsgContent();
      },
    },
    // 消息值变化为final时触发变更。
    // 防止收到的数据只有final变化但是内容没变化。
    'message.content.is_final': {
      immediate: true,
      handler(val) {
        if (val) {
          this.animateMsgContent();
        }
      },
    },
  },
  mounted() {
  },
  methods: {
    /**
     * 消息动画
     */
    animateMsgContent() {
      if (this.message.fromHisotry) {
        // 历史消息无动画
        this.msgContent = this.fullContent;
      } else {
        if (!this.fakeTypingTimer) {
          this.fakeTypingTimer = setInterval(() => {
            this.splitMsgContennt();
            console.log('fakeTypingTimer');
            if (this.contentCompleted) {
              // 两者内容一致了，停止计时器
              clearInterval(this.fakeTypingTimer);
              this.fakeTypingTimer = null;
            }
          }, 100);
        };
      }
    },
    /**
     * 切割消息文本，实现打字效果
     */
    splitMsgContennt() {
      // 动态范围
      const STEP = Math.ceil(1 + Math.random() * 3);
      this.currentIndex += STEP;
      this.msgContent = this.fullContent.substring(0, this.currentIndex);
    },
  },
};
</script>
<style lang="less" scoped>
// 代码高亮
@import '~highlight.js/styles/default.min.css';

.markdown-msg{
    .content {
        font-size: 14px;
        line-height: 1.4;
        word-break: break-word;
        word-wrap: break-word;
        text-align: left;

        // 优化markdown样式
        ::v-deep {
          img {
              max-width: 100%;
          }

          .hljs{
            background: #F1F2F5;
            padding: 8px;
            border-radius: 4px;
            display: flex;

            .overflow-x-auto{
              // 处理代码太长无法换行问题。需要配合父级的 display: flex;
              overflow-x: auto;
              flex: 1;
            }
          }

          // 只对一级p子dom 进行处理。否则对其他样式i显示不友好
          // 防止内容不超过一行时，因为上下margin撑开容器，导致和普通文本消息表现不一致看起来比较高的问题。
          >p{
            margin-top: 0;
            &:last-of-type{
              margin-bottom: 0;
            }
          }
          pre,
          code{
            font-family: inherit;
          }
          @keyframes blink {
            0% {
              opacity: 1;
            }
            50% {
              opacity: 0;
            }
            100% {
              opacity: 1;
            }
          }
          .cursor {
            display: inline-block;
            width: 2px;
            height: 17px;
            vertical-align: text-bottom;
            background-color: black;
            animation: blink 1s infinite;
          }

          @bdc: 1px solid #E2E5EA;
          table{
            width: 100%;
            border-collapse: collapse;
            border-radius: 6px;
            border: @bdc;

            tr{
              border-bottom: @bdc;
            }

            th, td{
              font-size: 14px;
              color: rgba(0, 1, 10, 0.93);
              background: #fff;
              padding: 12px 8px;
              border-right: @bdc;
              vertical-align: top;
              &:last-child{
                border-right: 0;
              }
            }

            th, td:first-of-type{
              color: rgba(3, 10, 38, 0.65);
              background: #F4F5F7;
            }
          }

          // 引用
          blockquote{
            border-left: 0.25em solid #ccc;
            margin: 1em 0;
            padding: 0 1em;
          }

          // 无序列表
          ul{
            list-style: disc;
            padding-left: 2em;
            margin-bottom: 1em;
          }
          // 有序列表
          ol{
            list-style: decimal;
            padding-left: 2em;
            margin-bottom: 1em;
          }
        }
    }

    &.pc{
        .content{
            ::v-deep .hljs{
                background: #fff;
            }
        }
    }

    .ai-msg-tag{
      text-align: right;
      color: #999;
    }

    .reference{
      margin-top: 8px;
      font-size: 14px;
      line-height: 20px;
      .tit{
        color: rgba(1, 11, 50, 0.41);
      }
      .article-link{
        .icon-papers{
          width: 16px;
          height: 16px;
          fill: currentColor;
          vertical-align: middle;
          margin-right: 4px;
        }
        span{
          vertical-align: middle;
        }
      }
    }
}
.pc.pc-not-frame {
  .markdown-msg {
    .content {
      font-size: 15px;
      line-height: 21px;
      ::v-deep {
        th, td {
          font-size: 15px;
        }
      }
    }
    .reference {
      font-size: 15px;
      line-height: 21px;
    }
  }
}
</style>
